import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ValidatorService } from 'app/core/service/app/validator.service';
import { CatalogueService } from 'app/core/service/core/cataloque.service';
import { FormBaseComponent } from 'app/form/core/component/form-base/form-base.component';

@Component({
  selector: 'app-obligado-solidario-direccion',
  templateUrl: './obligado-solidario-direccion.component.html',
  styleUrls: ['./obligado-solidario-direccion.component.scss']
})
export class ObligadoSolidarioDireccionComponent extends FormBaseComponent<any> implements OnInit {

  listColony = [];
  codigoPostal = '0';


  constructor(
      private validatorService: ValidatorService,
      private catalogueService: CatalogueService
    ) {
    super();

  }

  ngOnInit() {
    this.init(true);
    

    if (this.codigoPostal) {
      this.loadData(this.codigoPostal);
    }
    this.form.valueChanges.subscribe(state => {
      if (this.codigoPostal != state.cp) {
        this.codigoPostal = state.cp;
        this.loadData(this.codigoPostal);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.cp) {
        if (changes.cp.currentValue != this.codigoPostal) {
          this.loadData(changes.cp.currentValue);
          this.codigoPostal = changes.cp.currentValue;
        }
        if (this.form) {
          this.form.patchValue({ cp: changes.cp.currentValue });
        }
      }
    }
  }

  template() {
    this.form.addControl('calle', new FormControl(""));
    this.form.addControl('noInt', new FormControl(""));
    this.form.addControl('noExt', new FormControl(""));
    this.form.addControl('cp', new FormControl(""));
    this.form.addControl('colonia', new FormControl(0));
    this.form.addControl('estado', new FormControl(""));
    this.form.addControl('municipio', new FormControl(""));
    
  }


  loadData(value: string) {
    if(value != undefined && value.length == 5)
    {
      if (value != '00000' && value.length > 0 && value != "0") {
        this.listColony = [];
        this.catalogueService.getByPostalCode(value).then(result => {
          if (result != undefined)
          {
            this.form.patchValue({
              estado: result.state,
              municipio: result.municipality
            });

            result.colonies.map(item => {
              let colony = { text: item.text, value: item.value };
              if (this.listColony.indexOf(colony) === -1) {
                this.listColony.push(colony);
              }
            });
          }
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/obligado-solidario-direccion/obligado-solidario-direccion.component.ts